import { render, staticRenderFns } from "./ConstructionType.vue?vue&type=template&id=81edf326"
import script from "./ConstructionType.vue?vue&type=script&lang=js"
export * from "./ConstructionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports